import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-stardetails',
    templateUrl: './stardetails.component.html',
    styleUrls: ['./stardetails.component.scss'],
    standalone: false
})
export class StardetailsComponent {
  @Input() rating: number;
  @Input() reviews: number;
  @Input() starOnly: boolean;
  @Input() flow: string = 'column';

  private _rating: number;
}
